"use strict";

exports.__esModule = true;
exports.MAX_USERNAME_LENGTH = exports.MAX_BLOG_MENU_LABEL_LENGTH = exports.MAX_CATEGORY_DESCRIPTION_LENGTH = exports.MAX_CATEGORY_LABEL_LENGTH = exports.MAX_BLOG_DESCRIPTION_LENGTH = exports.MAX_BLOG_LABEL_LENGTH = void 0;
var MAX_BLOG_LABEL_LENGTH = 25;
exports.MAX_BLOG_LABEL_LENGTH = MAX_BLOG_LABEL_LENGTH;
var MAX_BLOG_DESCRIPTION_LENGTH = 120;
exports.MAX_BLOG_DESCRIPTION_LENGTH = MAX_BLOG_DESCRIPTION_LENGTH;
var MAX_CATEGORY_LABEL_LENGTH = 25;
exports.MAX_CATEGORY_LABEL_LENGTH = MAX_CATEGORY_LABEL_LENGTH;
var MAX_CATEGORY_DESCRIPTION_LENGTH = 120;
exports.MAX_CATEGORY_DESCRIPTION_LENGTH = MAX_CATEGORY_DESCRIPTION_LENGTH;
var MAX_BLOG_MENU_LABEL_LENGTH = 25;
exports.MAX_BLOG_MENU_LABEL_LENGTH = MAX_BLOG_MENU_LABEL_LENGTH;
var MAX_USERNAME_LENGTH = 25;
exports.MAX_USERNAME_LENGTH = MAX_USERNAME_LENGTH;